import { Add, Remove } from '@mui/icons-material';
import { Box, Button, Divider, Grid, Paper, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { IReportsRise, Monitoramentos } from '../../../../services/api/reports/ReportsServicesRise';

interface MonitoringRiseProps {
    dataRise?: IReportsRise;
    onDataChange: (data: Monitoramentos[]) => void;
}

export const MonitoringRise = ({ dataRise, onDataChange }: MonitoringRiseProps) => {
    
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    
    const [data, setData] = useState<Monitoramentos[]>([{ tipo: '', destaque: '' }]);

    useEffect(() => {
        if (dataRise?.monitoramentos && Object.keys(dataRise.monitoramentos).length > 0) {
            setData(dataRise.monitoramentos);
        }
    }, [dataRise]);

    const handleAdd = () => {
        const newItem: Monitoramentos = { tipo: '', destaque: '' };
        setData(prevDataSteps => [...prevDataSteps, newItem]);
    };

    const handleRemove = () => {
        if (data.length > 1) {
            setData(prevDataSteps => prevDataSteps.slice(0, -1));
        }
    };

    const handleMonitoringChange = (index: number, fieldName: keyof Monitoramentos, value: string) => {
        const updatedData = [...data];
        updatedData[index][fieldName] = value;
        setData(updatedData);
        onDataChange(updatedData);
    };

    return (
        <Box>
            <Box padding={1}>
                <Grid container>
                    <Grid item xs={12} marginBottom={1}>
                        <Typography variant='h5'>Interpretação dos monitoramentos</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Remove />}
                            onClick={handleRemove}
                            disabled={data.length <= 1}
                        >
                            Remover
                        </Button>
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Add />}
                            onClick={handleAdd}
                        >
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Box>
                {data.map((item, index) => (
                    <Box key={index} padding={1}>
                        <Box padding={1} component={Paper} variant='outlined' sx={{ borderRadius: '20px' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        label='Tipo de Monitoramento'
                                        value={item.tipo}
                                        fullWidth
                                        onChange={(e) => handleMonitoringChange(index, 'tipo', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label='Destaques'
                                        value={item.destaque}
                                        fullWidth
                                        onChange={(e) => handleMonitoringChange(index, 'destaque', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
